import React, { createContext, useContext, useMemo } from 'react';
import { createTrpcClient, type GetTokenFn } from '../trpcClient';

type TrpcClient = ReturnType<typeof createTrpcClient>;

const TrpcContext = createContext<TrpcClient | null>(null);

export function TrpcProvider({
  getToken,
  children,
}: {
  getToken: GetTokenFn;
  children: React.ReactNode;
}) {
  const client = useMemo(() => createTrpcClient(getToken), [getToken]);

  return (
    <TrpcContext.Provider value={client}>
      {children}
    </TrpcContext.Provider>
  );
}

export function useTrpcClient(): TrpcClient {
  const client = useContext(TrpcContext);
  if (!client) {
    throw new Error('useTrpcClient must be used within TrpcProvider');
  }
  return client;
}
